module.exports = __webpack_public_path__ + "static/media/1028105.1bfb31e8.png";